import { UrlApi } from "../../../../../services/apirest";
import { buildQueryParams } from "../utils/buildQueryParams";

export const exportPdf = (idCliente, tipoCliente, filtros) => {
  const query = buildQueryParams(filtros);

  window.open(
    `${UrlApi}/cuentaCorriente/pdf/${idCliente}/${tipoCliente}?${query}`,
    "_blank",
  );
};

export const exportExcel = (idCliente, tipoCliente, filtros) => {
  const query = buildQueryParams(filtros);

  window.open(
    `${UrlApi}/cuentaCorriente/excel/${idCliente}/${tipoCliente}?${query}`,
    "_blank",
  );
};
